import { Flex, Text } from '@auviknetworks/iceberg-ui';
import { useTheme } from '@mui/material/styles';
import { INTEGRATION_OPTION_GOOGLE_AUTOMATED } from 'application/Shared/Components/Client';
import { SaveAndContinue } from 'application/Shared/Components/Client/Forms/components/SaveAndContinue';
import { ConfigureIntegration } from 'application/Shared/Components/Client/Steps/ConfigureIntegration';
import { Route } from 'application/Shared/Helpers';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router';

export const QuickScanConfigureStep = ({
    integrationType,
    setLinkedTenantId
}) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const navigate = useNavigate();
    const [currentIntegrationType, setCurrentIntegrationType] =
        useState(integrationType);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const { partnerId } = useParams();
    const basePartnerRoute = Route.buildBasePartnerRoute({ partnerId });

    const translationKey =
        integrationType === INTEGRATION_OPTION_GOOGLE_AUTOMATED
            ? 'google'
            : 'microsoftEntraID';

    return (
        <Flex
            alignItems="center"
            data-testid="onboardingQuickScanConfigureADStep"
            flexDirection="column"
            mt={4}
            mx="4%"
        >
            <Text
                fontSize={['32px', '32px', '32px', 5]}
                color={theme.palette.onboarding.titleTextColor}
                fontWeight="600"
                textAlign="center"
            >
                {t('Onboarding.quickScanConfigure.title')}
            </Text>
            <Text
                fontSize={4}
                color={theme.palette.onboarding.titleTextColor}
                my={4}
                textAlign="center"
            >
                {t(`Onboarding.quickScanConfigure.${translationKey}.subtitle`)}
            </Text>
            <ConfigureIntegration
                onboarding
                integrationType={currentIntegrationType}
                onSuccess={(linkedTenantId) => {
                    navigate(
                        `${basePartnerRoute}/onboarding/quickScan/chooseGroups?clientId=${linkedTenantId}&provider=${currentIntegrationType}`
                    );
                }}
                formFooterComponent={
                    <SaveAndContinue
                        isSubmitting={isSubmitting}
                        buttonText={t('Common.continue')}
                    />
                }
                filterExistingSyncedTenants
                setIntegrationType={setCurrentIntegrationType}
                useIntegrationWizard={false}
                setIsSubmitting={setIsSubmitting}
                setLinkedTenantId={setLinkedTenantId}
            />
        </Flex>
    );
};
